export const animationLoaderStyles = () => ({
  animationContainer: {
    my: 1.5,
    height: '50px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    pl: 1
  }
});
